import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class GridComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

}



// WEBPACK FOOTER //
// ./src/app/features/grid/grid.component.ts